import SocialProofCard, { SocialProofCardProps } from '@/components/_atoms/social-proof-cards/SocialProofCard';
import Star from '@/components/Star';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface SocialProofReviewSiteCardProps extends SocialProofCardProps {
  name: string;
  nameSubhead: string;
  image: ReactNode;
  excerpt?: string;
  stars: number;
}

const SocialProofReviewSiteCard: FC<SocialProofReviewSiteCardProps> = (props) => {
  return (
    <StyledSocialProofCard cta={props.cta}>
      <QuoteeWrapper>
        {props.image ? <QuoteeAvatar>{props.image}</QuoteeAvatar> : null}

        <QuoteeTextWrapper>
          <QuoteeName>{props.name}</QuoteeName>
          <QuoteeTitle>{props.nameSubhead}</QuoteeTitle>
        </QuoteeTextWrapper>
      </QuoteeWrapper>

      {props.stars > 0 && (
        <StarWrapper>
          {Array(5)
            .fill('')
            .map((s, i) => (
              <Star key={`star-wrapper-${i}`} width={26} fillPercent={Math.max(0, Math.min(1, props.stars - i))} />
            ))}
        </StarWrapper>
      )}

      {props.excerpt && (
        <Excerpt>
          <p>{props.excerpt}</p>
        </Excerpt>
      )}

      {props.children && <Content>{props.children}</Content>}
    </StyledSocialProofCard>
  );
};

export default SocialProofReviewSiteCard;

// Styled Components

const StyledSocialProofCard = styled(SocialProofCard)`
  display: flex;
  flex-direction: column;
  row-gap: ${remCalc(22)};
  justify-content: flex-start;

  ${mediaBreakpointUp('tablet')} {
    row-gap: ${remCalc(24)};
  }
`;

const Excerpt = styled.blockquote`
  ${customTextSize(18, 26)};

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 34)};
  }
`;

const Content = styled.div`
  ${customTextSize(14, 20)};

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(16, 24)};
  }
`;

const StarWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: ${remCalc(8)};
`;

const QuoteeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  column-gap: 12px;
  align-items: center;

  ${mediaBreakpointUp('tablet')} {
    column-gap: 1rem;
  }
`;

const QuoteeTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const QuoteeName = styled.span`
  ${customTextSize(16, 26)};
  font-weight: ${FONT_WEIGHTS.BOLD};
`;

const QuoteeTitle = styled.span`
  ${customTextSize(14, 20)};
`;

const QuoteeAvatar = styled.div`
  position: relative;
  ${square(40)};
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;

  ${mediaBreakpointUp('tablet')} {
    ${square(50)};
  }
`;
